
/* injects from baggage-loader */

export const balloons = [
    'Que legal! Agora somos chefs! Que tal montarmos um cardápio diversificado? Vamos escolher pratos das regiões para o nosso cardápio!',
    'Ah! Mas não vamos esquecer de criar um nome para o nosso restaurante!'
]

export const balloons2 = [
    'Muito bem! Agora que você nomeou o seu restaurante, montaremos o cardápio com os pratos que serão servidos. <strong>Vamos lá</strong>?',
    'Aqui você poderá montar cada seção do cardápio com os pratos das regiões que você conheceu anteriormente.',
    'Arraste os blocos para os espaços correspondentes. Caso deseje escrever um novo prato ou um novo preço, clique em <div class="btnEditTutorial"></div> e digite a palavra.'
]



// WEBPACK FOOTER //
// ./src/app/pages/stage-sixth/stage-sixth.const.js